import { render, staticRenderFns } from "./SettingsCompany.vue?vue&type=template&id=16a84d4a&"
import script from "./SettingsCompany.vue?vue&type=script&lang=js&"
export * from "./SettingsCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports